<template>
  <div class="centerPage">
    <div class="breadCrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>历史分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="border">
      <div class="searchTab" style="display: block">
        <el-radio-group style="margin-bottom: 20px" v-model="condition.examType" size="small" @change="getData">
          <el-radio-button
              v-for="obj in types"
              :key="obj.id"
              :label="obj.id">
            {{ obj.itemName }}
          </el-radio-button>
        </el-radio-group>
        <el-radio-group size="small" v-model="condition.examStatus" @change="getData">
          <el-radio-button label="">所有</el-radio-button>
          <el-radio-button label="3">已完成</el-radio-button>
          <el-radio-button label="2">待评价</el-radio-button>
          <el-radio-button label="1">待分析</el-radio-button>
          <el-radio-button label="0">未提交</el-radio-button>
        </el-radio-group>
      </div>
      <div class="flex searchTab">
        <el-input v-model="condition.name" placeholder="请输入搜索关键词" size="small" @change="getData"></el-input>
      </div>

      <!--          @sort-change="sortChange"-->

      <el-table
          v-if="data!=0"
          class="record-table"
          :data="data"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 500px)"
      >
        <el-table-column label="测试单号" prop="resultNo" align="center" width="160"></el-table-column>
        <el-table-column label="测试名称" prop="title" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="测试类型" prop="itemName" align="center"></el-table-column>
        <el-table-column label="测试时间" align="center" prop="examDate" :sort-orders="['ascending', 'descending']"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" prop="examStatus" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.examStatus===0" type="warning">未提交</el-tag>
            <el-tag v-if="scope.row.examStatus===1" type="info">待分析</el-tag>
            <el-tag v-if="scope.row.examStatus===2">待评价</el-tag>
            <el-tag v-if="scope.row.examStatus===3" type="success">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付金额(元)" align="center" prop="expense">
          <template slot-scope="scope">
            <span class="disabled">{{ scope.row.expense }}</span>
          </template>
        </el-table-column>
        <el-table-column label="测试人" prop="userName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作者" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.resultType === 1 ? '系统评判' : scope.row.doctorName == null ? '无' : scope.row.doctorName }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button size="mini" class="detail"
                       @click="$router.push({path: 'detail', query: {no: scope.row.resultNo}})">查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="empty" v-else>
        <img src="../../../assets/img/no.png" alt="" width="200">
        <p>这里什么都没有</p>
      </div>
      <el-pagination
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "examHistoryList",
  data() {
    return {
      page: {
        current: 1,
        size: 8,
        total: 10,

      },
      condition: {
        name: this.$route.query.name || '',
        examType: '',
        examStatus: '',
      },
      data: [],
      types: [{
        id: 0,
        itemName: '所有',
        list: []
      }],
    }
  },
  mounted() {
    this.$ajax.get(commonjs.api.dict.exam.type).then((res) => {
      if (res.data.status === 'success') {
        this.types = this.types.concat(res.data.list);
      }
    });
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax
          .post(commonjs.manager_api.exam.historyList.replace("{current}/{size}", this.page.current + "/" + this.page.size), this.condition)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.page.total = res.data.total;
              that.data = res.data.rows;
            }
          })
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/patients.scss';
@import "../../../assets/css/personalCenter.scss";

.centerPage {
  display: block;
  width: auto;

}

.detail {
  border-color: #567BFF;
  color: #567BFF;
  background: #ffffff;

  &:hover, &:focus {
    color: #567BFF;
    border-color: #567BFF;
    background-color: #ffffff;
  }
}
</style>